import { Paper as PaperComponent, PaperProps, styled } from '@mui/material';

export const Paper = styled(PaperComponent)<PaperProps>(({ theme }) => ({
    borderRadius: theme.spacing(0.75),
    boxShadow: 'none',
    ':focus-visible': {
        outline: 'none'
    }
})) as typeof PaperComponent;
